import { useEffect, useState } from 'react';
import { SESSION_CLEARED_EVENT, SESSION_STARTED_EVENT } from '@utils/session-events';

export const readHasSession = (): boolean => typeof window !== 'undefined' && !!localStorage.getItem('accessToken');

/**
 * Whether a session exists, kept in state: it flips on sign-in and sign-out
 * within the SPA, so a query gated on it enables after a login without a
 * page reload.
 */
export function useHasSession(): boolean {
  const [hasSession, setHasSession] = useState(readHasSession);
  useEffect(() => {
    const sync = () => setHasSession(readHasSession());
    window.addEventListener(SESSION_STARTED_EVENT, sync);
    window.addEventListener(SESSION_CLEARED_EVENT, sync);
    // Another tab signing in or out changes the shared token.
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(SESSION_STARTED_EVENT, sync);
      window.removeEventListener(SESSION_CLEARED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return hasSession;
}
